// extracted by mini-css-extract-plugin
module.exports = {"container":"_3d200474","search_text":"_0fb54345"};